/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetInventoryDocumentResponse
 */
export interface AssetInventoryDocumentResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDocumentResponse
     */
    documentId: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDocumentResponse
     */
    sourceFileId: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDocumentResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDocumentResponse
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDocumentResponse
     */
    contentType: string;
    /**
     * 
     * @type {number}
     * @memberof AssetInventoryDocumentResponse
     */
    fileSizeBytes: number;
    /**
     * 
     * @type {boolean}
     * @memberof AssetInventoryDocumentResponse
     */
    isPreviewAvailable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetInventoryDocumentResponse
     */
    isRead: boolean;
    /**
     * 
     * @type {Date}
     * @memberof AssetInventoryDocumentResponse
     */
    createdAtUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryDocumentResponse
     */
    createdByUserCode: string;
}

/**
 * Check if a given object implements the AssetInventoryDocumentResponse interface.
 */
export function instanceOfAssetInventoryDocumentResponse(value: object): value is AssetInventoryDocumentResponse {
    if (!('documentId' in value) || value['documentId'] === undefined) return false;
    if (!('sourceFileId' in value) || value['sourceFileId'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('contentType' in value) || value['contentType'] === undefined) return false;
    if (!('fileSizeBytes' in value) || value['fileSizeBytes'] === undefined) return false;
    if (!('isPreviewAvailable' in value) || value['isPreviewAvailable'] === undefined) return false;
    if (!('isRead' in value) || value['isRead'] === undefined) return false;
    if (!('createdAtUtc' in value) || value['createdAtUtc'] === undefined) return false;
    if (!('createdByUserCode' in value) || value['createdByUserCode'] === undefined) return false;
    return true;
}

export function AssetInventoryDocumentResponseFromJSON(json: any): AssetInventoryDocumentResponse {
    return AssetInventoryDocumentResponseFromJSONTyped(json, false);
}

export function AssetInventoryDocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetInventoryDocumentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'documentId': json['documentId'],
        'sourceFileId': json['sourceFileId'],
        'clientId': json['clientId'],
        'fileName': json['fileName'],
        'contentType': json['contentType'],
        'fileSizeBytes': json['fileSizeBytes'],
        'isPreviewAvailable': json['isPreviewAvailable'],
        'isRead': json['isRead'],
        'createdAtUtc': (new Date(json['createdAtUtc'])),
        'createdByUserCode': json['createdByUserCode'],
    };
}

export function AssetInventoryDocumentResponseToJSON(json: any): AssetInventoryDocumentResponse {
    return AssetInventoryDocumentResponseToJSONTyped(json, false);
}

export function AssetInventoryDocumentResponseToJSONTyped(value?: AssetInventoryDocumentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentId': value['documentId'],
        'sourceFileId': value['sourceFileId'],
        'clientId': value['clientId'],
        'fileName': value['fileName'],
        'contentType': value['contentType'],
        'fileSizeBytes': value['fileSizeBytes'],
        'isPreviewAvailable': value['isPreviewAvailable'],
        'isRead': value['isRead'],
        'createdAtUtc': value['createdAtUtc'].toISOString(),
        'createdByUserCode': value['createdByUserCode'],
    };
}

